var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0.5C15.2431 0.5 19.5 4.75693 19.5 10C19.5 15.2431 15.2431 19.5 10 19.5C4.75693 19.5 0.5 15.2431 0.5 10C0.5 4.75693 4.75693 0.5 10 0.5ZM5.85475 9.84615L8.05088 11.3105C8.22373 11.4255 8.45173 11.4116 8.60976 11.2767L14.5642 6.17266C14.7486 6.01416 15.0243 6.02576 15.1953 6.19861C15.3663 6.371 15.3747 6.64674 15.2148 6.82978L8.727 14.2444C8.63477 14.3492 8.50039 14.4075 8.36044 14.402C8.22096 14.3969 8.0912 14.3288 8.00732 14.2171L5.22683 10.5098C5.09151 10.329 5.10588 10.0774 5.26112 9.91334C5.4159 9.7493 5.6666 9.72103 5.85475 9.84615Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.ed74d8a5603df40d0fa884eb357014bb.svg";
export { ForwardRef as ReactComponent };